import Log from 'modules/user-management/log';

export default function LogPage() {
  return <Log />;
}
